import React, { ReactElement, useEffect, useRef, FC } from 'react'
import './style.scss'
interface Props {
  party: string
  color: string
  seatsNew: number
  seatsDisplay: string
  seatsChange: number
}
export const ParliamentTableRow: FC<Props> = ({
  party,
  color,
  seatsNew,
  seatsDisplay,
  seatsChange
}): ReactElement => {
  const formattedSeatsChange = seatsChange > 0 ? '+' + seatsChange : seatsChange

  return (
    <span className={color.replace('#', '')}>
      <div className='party-color' style={{ backgroundColor: color }} />
      <div className='' />
      <div className='party-name border-bottom'> {party}</div>
      <div className='party-seats border-bottom'>
        {' '}
        {seatsDisplay || seatsNew}
      </div>
      {/* <div
        className={
          (formattedSeatsChange > 0
            ? 'win-color'
            : formattedSeatsChange < 0
            ? 'lose-color'
            : '') + ' party-seats-seats-change border-bottom'
        }
      >
        {' '}
        {formattedSeatsChange}
      </div> */}
    </span>
  )
}
